/**
 * Excepciones de menú para Naomi Sarai Palma Mendez (iderp 2781).
 * El iderp 2797 comparte: Solicitar Cambio Horario, Acceso a CRM's,
 * Coordinación de sucursales y Corte diario (todas las sucursales).
 */
export const IDERP_NAOMI_PALMA = 2781
export const IDERPS_CAMBIO_HORARIO = [2781, 2797]
export const IDERPS_ACCESO_CRM = [2781, 2797]
export const IDERPS_COORDINACION_SUCURSALES = [2781, 2797]
export const IDERPS_CORTE_DIARIO = [2781, 2797]

const ACCIONES = [
  {
    idmenu: 6,
    menuTitle: 'RH',
    path: 'CambioHorario',
    title: 'Solicitar Cambio Horario',
    icon: 'mdi mdi-circle-medium theme--light',
    iderps: IDERPS_CAMBIO_HORARIO,
  },
  {
    idmenu: 9,
    menuTitle: 'Marketing',
    path: 'AccesoCRM',
    title: "Acceso a CRM's",
    icon: 'mdi mdi-circle-medium theme--light',
    iderps: IDERPS_ACCESO_CRM,
  },
  {
    idmenu: 6,
    menuTitle: 'RH',
    categoryTitle: 'Checador',
    path: 'VisualizadorEntradas',
    title: 'Coordinación de sucursales',
    icon: 'mdi mdi-circle-medium theme--light',
    iderps: IDERPS_COORDINACION_SUCURSALES,
  },
  {
    idmenu: 5,
    menuTitle: 'Operaciones',
    path: 'CorteDiario',
    title: 'Corte diario',
    icon: 'mdi mdi-circle-medium theme--light',
    iderps: IDERPS_CORTE_DIARIO,
  },
]

function menuTienePath(menu, path) {
  if (!Array.isArray(menu)) return false
  for (const top of menu) {
    for (const cat of top.items || []) {
      if (cat && cat.path === path) return true
      for (const child of cat.items || []) {
        if (child && child.path === path) return true
      }
    }
  }
  return false
}

export function esAccesoMenuNaomi(iderp) {
  return Number(iderp) === IDERP_NAOMI_PALMA
}

export function esAccesoCambioHorario(iderp) {
  return IDERPS_CAMBIO_HORARIO.includes(Number(iderp))
}

export function esAccesoCRM(iderp) {
  return IDERPS_ACCESO_CRM.includes(Number(iderp))
}

export function esAccesoCoordinacionSucursales(iderp) {
  return IDERPS_COORDINACION_SUCURSALES.includes(Number(iderp))
}

export function esAccesoCorteDiario(iderp) {
  return IDERPS_CORTE_DIARIO.includes(Number(iderp))
}

/**
 * Inyecta las acciones permitidas por iderp si aún no están en el menú del puesto.
 */
export function asegurarMenuNaomiPalma(menu, iderp) {
  const id = Number(iderp)
  const list = Array.isArray(menu) ? menu : []
  const acciones = ACCIONES.filter((a) => a.iderps.includes(id))
  if (!acciones.length) return list

  for (const a of acciones) {
    if (menuTienePath(list, a.path)) continue

    let target = list.find((m) => Number(m.idmenu) === a.idmenu)
    if (!target) {
      target = {
        title: a.menuTitle,
        idmenu: a.idmenu,
        path: null,
        items: [],
      }
      list.push(target)
    }
    if (!Array.isArray(target.items)) target.items = []

    const action = {
      title: a.title,
      path: a.path,
      icon: a.icon,
      active: 1,
    }

    if (a.categoryTitle) {
      let cat = target.items.find((c) => c && c.title === a.categoryTitle)
      if (!cat) {
        cat = { title: a.categoryTitle, items: [] }
        target.items.push(cat)
      }
      if (!Array.isArray(cat.items)) cat.items = []
      cat.items.push(action)
    } else {
      target.items.push(action)
    }
  }

  return list
}
